import { Button } from './Button';

interface AdminViewHeaderProps {
    gridCols?: string;
    cols: ButtonCol & Cols;
}

type ButtonCol = {
    button?: {
        text: string;
        function: () => void;
        renderCondition?: boolean;
        className?: string;
    };
};

type Cols = {
    cols?: {
        text?: string;
        className?: string;
        hideCol?: boolean;
    }[];
};

function AdminViewHeader({ gridCols = 'grid-cols-4', cols }: AdminViewHeaderProps) {
    if (cols.button) cols.button.renderCondition = cols.button.renderCondition ?? true;

    return (
        <div className={`grid ${gridCols} gap-4 w-full px-4`}>
            {cols.cols &&
                cols.cols.map((col, index) => {
                    if (col.hideCol) {
                        return <></>;
                    }

                    return (
                        <div key={index} className={`text-lg flex items-center ${col.className ?? ''}`}>
                            <strong>{col.text}</strong>
                        </div>
                    );
                })}

            {cols.button && (
                <div className={`flex justify-end ${cols?.button?.className ?? ''}`}>
                    {cols.button.renderCondition && (
                        <Button variant="primary" className="h-[51px]" onClick={cols.button.function}>
                            {cols.button.text}
                        </Button>
                    )}
                </div>
            )}
        </div>
    );
}

export default AdminViewHeader;
